var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilesCsvIndex({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16.1818,
    y: 21.2727,
    width: 16.3636,
    height: 13.1818,
    fill: "#44E02B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.4609 14.2664L30.4609 4.26636C30.2905 4.09591 30.0591 4 29.8182 4H8.90909C8.40727 4 8 4.40727 8 4.90909V43.0909C8 43.5927 8.40727 44 8.90909 44H39.8182C40.32 44 40.7273 43.5927 40.7273 43.0909V14.9091C40.7273 14.6682 40.6314 14.4368 40.4609 14.2664ZM30.7273 7.10364L37.6232 14H30.7273V7.10364ZM9.81818 42.1818V5.81818H28.9091V14.9091C28.9091 15.4109 29.3164 15.8182 29.8182 15.8182H38.9091V42.1818H9.81818Z",
    fill: "#33475B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5456 20.3636H16.182C15.6801 20.3636 15.2729 20.7709 15.2729 21.2727V34.9091C15.2729 35.4109 15.6801 35.8182 16.182 35.8182H32.5456C33.0474 35.8182 33.4547 35.4109 33.4547 34.9091V21.2727C33.4547 20.7709 33.0474 20.3636 32.5456 20.3636ZM31.6365 24.9091H22.5456V22.1818H31.6365V24.9091ZM17.091 26.7273H20.7274V29.4545H17.091V26.7273ZM22.5456 26.7273H31.6365V29.4545H22.5456V26.7273ZM20.7274 22.1818V24.9091H17.091V22.1818H20.7274ZM17.091 31.2727H20.7274V34H17.091V31.2727ZM22.5456 34V31.2727H31.6365V34H22.5456Z",
    fill: "#33475B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilesCsvIndex);
export default __webpack_public_path__ + "static/media/files-csv-index.f559c2edf58d0e84d98205e5f45b6e57.svg";
export { ForwardRef as ReactComponent };